import script from "./InformationDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationDetails.vue?vue&type=script&setup=true&lang=js"

import "./InformationDetails.vue?vue&type=style&index=0&id=5da157df&lang=css"

const __exports__ = script;

export default __exports__